import { Action, createReducer, on } from '@ngrx/store';
import {
  cashlessPaymentAction,
  cashlessPaymentErrorAction,
  cashlessPaymentSuccessAction,
  ClearStateAction,
  getPursesAction,
  getPursesErrorAction,
  getPursesSuccessAction,
  SetPurseTopupOptionsAction,
  SetPurseTopupOptionsErrorAction,
  SetPurseTopupOptionsSuccessAction,
  SetSelectedPurseIDAction,
} from './purses.actions';
import { PursesState } from './purses.state';

const initialState = new PursesState();

const reducer = createReducer(
  initialState,

  on(getPursesAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getPursesSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.purses = payload.purses;
    return newState;
  }),
  on(getPursesErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),

  on(SetPurseTopupOptionsAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(SetPurseTopupOptionsSuccessAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.purseTopupOption = { data: true };
    return newState;
  }),
  on(SetPurseTopupOptionsErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(cashlessPaymentAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(cashlessPaymentSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.cashlessResponse = payload.cashlessResponse ?? { result: 'ok' };
    return newState;
  }),
  on(cashlessPaymentErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(ClearStateAction, (state, payload) => {
    const newState = { ...state };
    switch (payload.actionType) {
      case 'purses':
        newState.purses = null;
        break;
      default:
        break;
    }
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  }),
  on(SetSelectedPurseIDAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.selectedPurseID = payload.selectedPurseID;
    return newState;
  })
);

export function PursesReducer(state: PursesState | null, action: Action) {
  return reducer(state, action);
}
